(function() {

    /**
     * Retourne la largeur d'une "page"
     * @param $zone Élément qui englobe les items du carrousel
     * @returns {number} Largeur à faire défiler
     */
    function getPageWidth($zone) {
        return $zone.clientWidth / 2 // <= Peut être amélioré, permet de s'assurer qu'on ne va pas sauter un item
    }

    /**
     * Met à jour l'affichage du carrousel
     * @param $wrapper Élément parent du carrousel
     * @param $zone Élément qui englobe les items du carrousel
     * @param $previous Boutons de pagination en arrière
     * @param $next Boutons de pagination en avant
     */
    function updateScrollerUI($wrapper, $zone, $previous, $next) {
        // Par défaut, on désactive les boutons de pagination
        let isPreviousEnabled = false
        let isNextEnabled = false

        // Si les items ne peuvent pas être tous affichés
        if ($zone.scrollWidth > $zone.clientWidth) {
            // On indique la possibilité de retourner en arrière
            isPreviousEnabled = $zone.scrollLeft > 0
            // On indique la possibilité d'aller en avant
            isNextEnabled = $zone.scrollLeft < ($zone.scrollWidth - $zone.clientWidth)
        }

        // Mise à jour de l'état des boutons précédent et suivant
        for (const $p of $previous) {
            $p.disabled = !isPreviousEnabled
        }
        for (const $n of $next) {
            $n.disabled = !isNextEnabled
        }
        // Ajout et suppression des classes dédiées
        $wrapper.classList.toggle('is-at-start', !isPreviousEnabled)
        $wrapper.classList.toggle('is-at-end', !isNextEnabled)
    }

    /**
     * Initialise le carrousel
     * @param $wrapper Élément parent du carrousel
     */
    function bindScroller($wrapper) {
        // $zone : Élément qui englobe les items du carrousel
        // $previous : Boutons de pagination en arrière
        // $next : Boutons de pagination en avant
        // $items : Items du carrousel
        // $itemsClickableZones : Zone cliquable des items du carrousel
        const $zone = $wrapper.querySelector('[data-scroller-zone]')
        const $previous = Array.from($wrapper.querySelectorAll('[data-scroller-previous]'))
        const $next = Array.from($wrapper.querySelectorAll('[data-scroller-next]'))
        const $items = Array.from($wrapper.querySelectorAll('[data-scroller-item]'))
        const $itemsClickableZones = Array.from($wrapper.querySelectorAll('[data-scroller-item-clickable-zone]'))

        // Au chargement de la page, on remet le carrousel au début
        $zone.scrollLeft = 0

        // Prise en charge des boutons de pagination en arrière
        for (const $p of $previous) {
            $p.addEventListener('click', () => {
                const left = getPageWidth($zone) * -1
                $zone.scrollBy({ left })
            })
        }

        // Prise en charge des boutons de pagination en avant
        for (const $n of $next) {
            $n.addEventListener('click', () => {
                const left = getPageWidth($zone)
                $zone.scrollBy({ left })
            })
        }

        // Quand les zones cliquables des items reçoivent le focus, on les déplace au centre pour s'assurer de leur bonne visibilité
        for (const $i of $itemsClickableZones) {
            $i.addEventListener('focus', () => {
                $i.scrollIntoView({ block: 'nearest', inline: 'center' })
            })
        }

        // En cas de resize ou scroll du wrapper, on met à jour l'interface du carrousel
        new ResizeObserver(() => updateScrollerUI($wrapper, $zone, $previous, $next)).observe($zone)
        $zone.addEventListener('scroll', () => updateScrollerUI($wrapper, $zone, $previous, $next))
        // Premier appel pour initialisation
        updateScrollerUI($wrapper, $zone, $previous, $next)
    }

    // On déclenche l'initialisation des carrousels quand la page est prête
    window.addEventListener('load', () => {
        const $scrollers = Array.from(document.querySelectorAll('.js-scroller'))
        for (const $scroller of $scrollers) {
            bindScroller($scroller)
        }
    })
})()